import CheckoutComponent from "./CheckoutComponent";

export default class CheckoutPickup {
    private BX: any;
    private ymaps: any;
    private mapId: any;
    private shopListId: any;
    private basketGroupId: any;
    private pickUpOptions: any;
    private propsOptions: any;
    private maxWaitTimeExpired: any;
    private pickUpMap: any;
    private pickUpPointsJSON: any;
    private pickUpMapFocused: any;


    constructor(BX: any, ymaps: any, mapId: any, shopListId: any, basketGroupId: any) {
        this.BX = BX;
        this.ymaps = ymaps;
        this.mapId = mapId;
        this.shopListId = shopListId;
        this.basketGroupId = basketGroupId ? basketGroupId : 0;
    }

    init() {
        let self = this;
        this.pickUpOptions = {
            defaultMapPosition: {
                lat: 55.76,
                lon: 37.64,
                zoom: 7,
            },
            geoLocationMaxTime: 5000,
            minToShowNearestBlock: 3,
            nearestPickUpsToShow: 3,
            secureGeoLocation: false,
        };
        this.propsOptions = {
            defaultMapPosition: {
                lat: 55.76,
                lon: 37.64,
                zoom: 7,
            },
        };
        this.maxWaitTimeExpired = false;
        this.pickUpMapFocused = false;

        $('#'+this.mapId).empty();

        this.getStores(false);

        this.bindEvents();
        this.checkUserPosition();
    }

    bindEvents() {
        let self = this;
        $(document).on('click', '.pickup-list-item', function(){
            self.selectStore($(this).data('store-id'));
        });
        $(document).on('keyup', '#search_shops', function(){
            self.searchStore($(this).val());
        });
        $(document).off('click', '.pickup-dialog-link');
        $(document).on('click', '.pickup-dialog-link', function(){
            self.getStores(true);
        });
        $('#pickup-dialog').on('hide.bs.modal', function () {
            self.replaceModalContent();
        });
        $('.pickup-list-mode-btn').on('click', function(){
            self.setListMode();
        });
        $('.pickup-map-mode-btn').on('click', function(){
            self.setMapMode();
        });
        $(document).on('change', '.delivery-pickup-select', function(){
            let basketGroup = $(this).closest('.basket-group').data('group');
            CheckoutComponent.arResult.BASKET.GROUPS[basketGroup].SELECTED_PICKUP = $(this).val();
            CheckoutComponent.reloadComponents(['total']);
        });
    }

    setListMode() {
        let $dialog = $('#pickup-dialog');
        $dialog.find('.cart-pickupmap-wrapper').hide();
        $dialog.find('.cart-pickuplist-wrapper').show();
        $('.pickup-map-mode-btn').removeClass('checked');
        $('.pickup-list-mode-btn').addClass('checked');
    }

    setMapMode() {
        let $dialog = $('#pickup-dialog');
        $dialog.find('.cart-pickupmap-wrapper').show();
        $dialog.find('.cart-pickuplist-wrapper').hide();
        $('.pickup-map-mode-btn').addClass('checked');
        $('.pickup-list-mode-btn').removeClass('checked');
    }

    replaceModalContent() {
        let $dialog = $('#pickup-dialog');
        let $basketGroupParams = $('.basket-group[data-group="'+this.basketGroupId+'"]')
            .find('.delivery-item.checked')
            .find('.delivery-item-params');
        $dialog.find('.cart-pickuplist-wrapper, .cart-pickupmap-wrapper').appendTo($basketGroupParams);
    }

    searchStore(val: any) {
        $('#pickup-dialog .pickup-list-item').each(function () {
            var shop = $(this);
            var shopText = shop.text();
            if (val != '') {
                if (shopText.search(new RegExp(val, "i")) < 0) {
                    shop.css('display', 'none');
                } else {
                    shop.css('display', 'block');
                }
            } else {
                shop.css('display', 'block');
            }
        });
    }

    resizeMapContainers() {
        if($(window).width() > 767) {
            $('#pickup-dialog')
                .find('.modal-dialog')
                .css('width', $('.cart-delivery-wrapper').innerWidth() + 'px');
                var pickUpMapContainer = $('#'+this.mapId),
                    width, height;
                if (pickUpMapContainer) {
                    width = pickUpMapContainer.innerWidth();
                    height = width / 16 * 9;
                    pickUpMapContainer.css('height', (height + 'px'));
                }
        } else {
            let $dialog = $('#pickup-dialog');
            let $dialogHeader = $dialog.find('.modal-header');
            let height = $(window).height() - $dialogHeader.height();
            $('#'+this.mapId).css({'height':(height + 'px'), 'width':'100%'});

        }

    }

    getStores(bOpenDialog:boolean) {
        let self = this;
        let arProduct = [], productID;
        for(var k in CheckoutComponent.arResult.BASKET.GROUPS[this.basketGroupId].PRODUCTS) {
            productID = CheckoutComponent.arResult.BASKET.GROUPS[this.basketGroupId].PRODUCTS[k];
            arProduct.push({
                'productId': productID,
                'quantity' : CheckoutComponent.arResult.BASKET.ITEMS[productID]['QUANTITY']
            });
        }
        $.post(
            '/',
            {
                ajaxAction: 'getPickupStores',
                serviceId: CheckoutComponent.arResult.BASKET.GROUPS[self.basketGroupId].SELECTED_DELIVERY,
                products: arProduct,
            },
            function(data) {
                if (data.length) {
                    let $basketGroup = $('.basket-group[data-group="'+self.basketGroupId+'"]');
                    let $pickupSelect = $basketGroup.find('.delivery-item.checked').find('.delivery-pickup-select');
                    $pickupSelect.html('<option value="0">Выбрать магазин</option>');
                    for(var k in data) {
                        $pickupSelect.append('<option value="'+data[k].ID+'">'+data[k].ADDRESS+'</option>')
                    }
                    if(CheckoutComponent.arResult.BASKET.GROUPS[self.basketGroupId].SELECTED_PICKUP) {
                        $pickupSelect.val(CheckoutComponent.arResult.BASKET.GROUPS[self.basketGroupId].SELECTED_PICKUP);
                    }
                    $('.pickup-list-item[data-store-id="'+CheckoutComponent.arResult.BASKET.GROUPS[self.basketGroupId].SELECTED_PICKUP+'"]')
                        .addClass('checked');
                    if(typeof(CheckoutComponent.arResult.DELIVERY) == 'undefined') {
                        CheckoutComponent.arResult.DELIVERY = {};
                    }
                    CheckoutComponent.arResult.DELIVERY.PICKUP_STORES = data;
                    if(bOpenDialog) {
                        self.openDialog();
                        self.setMapMode();
                    }
                }
            },
            'json'
        );
    }

    openDialog() {
        let self = this;
        let $basketGroup = $('.basket-group[data-group="'+self.basketGroupId+'"]');
        let $dialog = $('#pickup-dialog');
        let $dialogBody = $dialog.find('.modal-body');
        $dialog.find('.modal-body').empty();

        if($(window).width() < 768) {
            $dialog.find('.modal-content').css('min-height', $(window).height()+'px');
        } else {
            $dialog.find('.modal-content').css('min-height', 'auto');
        }

        $dialog.appendTo('body').modal();
        $basketGroup
            .find('.delivery-item.checked')
            .find('.cart-pickuplist-wrapper, .cart-pickupmap-wrapper')
            .appendTo($dialogBody);

        self.resizeMapContainers();
        self.initializePickUpMap(CheckoutComponent.arResult.DELIVERY.PICKUP_STORES[0]);
        setTimeout(self.BX.proxy(self.pickUpMapFocusWaiter, self), 200);
        CheckoutComponent.reloadComponents([self.shopListId]);
        self.buildBalloons(CheckoutComponent.arResult.DELIVERY.PICKUP_STORES);

        $('.pickup-list-mode-btn').addClass('checked');
        $('.pickup-map-mode-btn').removeClass('checked');
        $dialog.find('.cart-pickuplist-wrapper').show();
        $dialog.find('.cart-pickupmap-wrapper').hide();

        return false;
    }

    initializePickUpMap(selected: any) {
        if (!this.ymaps || this.pickUpMap)
            return;
        this.pickUpMap = new this.ymaps.Map(this.mapId, {
            center: !!selected
                ? [selected.GPS_N, selected.GPS_S]
                : [this.pickUpOptions.defaultMapPosition.lat, this.pickUpOptions.defaultMapPosition.lon],
            zoom: this.pickUpOptions.defaultMapPosition.zoom,
            controls: ['geolocationControl','trafficControl','fullscreenControl','zoomControl']
        });

        this.pickUpMap.behaviors.disable('scrollZoom');

        this.pickUpMap.events.add('click', this.BX.delegate(function(){
            if (this.pickUpMap.balloon.isOpen())
            {
                this.pickUpMap.balloon.close();
            }
        }, this));
    }

    pickUpMapFocusWaiter() {
        if (this.pickUpMap && this.pickUpMap.geoObjects)
        {
            this.setPickUpMapFocus();
        }
        else
        {
            setTimeout(this.BX.proxy(this.pickUpMapFocusWaiter, this), 100);
        }
    }

    setPickUpMapFocus() {
        var bounds, diff0, diff1;

        bounds = this.pickUpMap.geoObjects.getBounds();
        if (bounds && bounds.length)
        {
            diff0 = bounds[1][0] - bounds[0][0];
            diff1 = bounds[1][1] - bounds[0][1];

            bounds[0][0] -= diff0/10;
            bounds[0][1] -= diff1/10;
            bounds[1][0] += diff0/10;
            bounds[1][1] += diff1/10;

            this.pickUpMap.setBounds(bounds, {checkZoomRange: true});
        }
    }

    checkUserPosition() {
        if (!this.ymaps)
            return;
        try {
            this.ymaps.geolocation.get({
                provider: 'yandex',
                timeOut: 5000
            }).then(
                this.BX.delegate(function(result: any){
                    if(typeof(result.geoObjects) != 'undefined') {
                        CheckoutComponent.arResult.DELIVERY.USER_POSITION = result.geoObjects.position;
                    }
                }, this)
            );
        } catch(err) {
            console.log(err);
        }
    }

    buildBalloons(activeStores: any) {
        if (!this.ymaps)
            return;

        var that = this;

        this.pickUpPointsJSON = [];

        for (const element of activeStores) {
            var storeInfoHtml = this.getStoreInfoHtml(element);

            this.pickUpPointsJSON.push({
                type: 'Feature',
                geometry: {type: 'Point', coordinates: [element.GPS_N, element.GPS_S]},
                properties: {storeId: element.ID}
            });

            let span = '';
            let activeStore = element;

            var geoObj = new this.ymaps.Placemark([element.GPS_N, element.GPS_S], {
                hintContent: this.BX.util.htmlspecialchars(element.TITLE) + '<br />' + this.BX.util.htmlspecialchars(element.ADDRESS),
                storeTitle: element.TITLE,
                storeBody: storeInfoHtml,
                id: activeStore.ID,
                text: 'Выбрать'
            }, {
                // Опции.
                // Необходимо указать данный тип макета.
                iconLayout: 'default#image',
                // Своё изображение иконки метки.
                iconImageHref: '/local/components/5lb/checkout.pickupmap/templates/.default/images/map-marker.png',
                // Размеры метки.
                iconImageSize: [40, 52],
                balloonContentLayout: this.ymaps.templateLayoutFactory.createClass(
                    '<h3>{{ properties.storeTitle }}</h3>'+ span +'<br\>' +
                    '{{ properties.storeBody|raw }}' +
                    '<br /><a class="btn btn-sm btn-default" data-store="{{ properties.id }}">{{ properties.text }}</a>',
                    {
                        build: function() {
                            this.constructor.superclass.build.call(this);

                            var button = document.querySelector('a[data-store]');
                            if (button)
                                that.BX.bind(button, 'click', this.selectStoreByClick);
                        },
                        clear: function() {
                            var button = document.querySelector('a[data-store]');
                            if (button)
                                that.BX.unbind(button, 'click', this.selectStoreByClick);

                            this.constructor.superclass.clear.call(this);
                        },
                        selectStoreByClick: function(e: any) {
                            let target = e.target;
                            let groupId = $(e.target).closest('.basket-group').data('group');
                            if (that.pickUpMap.container.isFullscreen())
                            {
                                that.pickUpMap.container.exitFullscreen();
                            }
                            that.selectStore(target.getAttribute('data-store'), groupId);

                        }
                    }
                )
            });
            this.pickUpMap.geoObjects.add(geoObj);
        }
    }

    selectStore(storeId: any) {
        CheckoutComponent.arResult.BASKET.GROUPS[this.basketGroupId].SELECTED_PICKUP = storeId;
        storeId = storeId.toString();
        let $modal = $('#pickup-dialog');
        let $basketGroup = $('.basket-group[data-group="'+this.basketGroupId+'"]');
        CheckoutComponent.reloadComponents(['total']);
        if($modal.find('.cart-pickupmap-wrapper').is(':visible')) {
            $basketGroup.find('.delivery-pickup-select').val(storeId);
            $modal.modal('hide');
            return;
        }
        if($modal.find('.cart-pickuplist-wrapper').is(':visible')) {
            $modal.find('.pickup-list-item.checked').removeClass('checked');
            $modal.find('.pickup-list-item#store-'+storeId).addClass('checked');
            $basketGroup.find('.delivery-pickup-select').val(storeId);
            return;
        }
    }

    getStoreInfoHtml(currentStore: any) {
        var html = '';

        if (currentStore.ADDRESS)
            html += 'Адрес' + ': ' + this.BX.util.htmlspecialchars(currentStore.ADDRESS) + '<br />';

        if (currentStore.PHONE)
            html += 'Телефон' + ': ' + this.BX.util.htmlspecialchars(currentStore.PHONE) + '<br />';

        if (currentStore.SCHEDULE)
            html += 'Режим работы' + ': ' + this.BX.util.htmlspecialchars(currentStore.SCHEDULE) + '<br />';

        if (currentStore.DESCRIPTION)
            html += 'Описание' + ': ' + this.BX.util.htmlspecialchars(currentStore.DESCRIPTION) + '<br />';

        return html;
    }
}